import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { useState } from "react";
import { Thumb } from "./Thumb.js";
import { SliderInput } from "./styles.js";
function RangeInput({
  min,
  max,
  value,
  onChange,
  inputPosition,
  isFromCenter = false,
  isInactive,
  isTooltipHidden,
  isDisabled,
  step
}) {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const isRange = Array.isArray(value);
  return /* @__PURE__ */ jsxs(Fragment, {
    children: [/* @__PURE__ */ jsx(SliderInput, {
      min,
      max,
      value: isRange ? value[0] : value,
      $values: value,
      type: "range",
      onChange,
      name: "min-input",
      step,
      onMouseDown: () => {
        setIsTooltipOpen(true);
      },
      onMouseUp: () => {
        setIsTooltipOpen(false);
      },
      $isFromCenter: isFromCenter,
      $isRange: isRange,
      $isDisabled: isDisabled,
      role: "slider",
      disabled: isDisabled
    }), /* @__PURE__ */ jsx(Thumb, {
      isTooltipOpen: isTooltipOpen && !isTooltipHidden,
      min,
      max,
      value: isRange ? value[0] : value,
      inputPosition,
      isInactive,
      isDisabled
    }), isRange && /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(SliderInput, {
        min,
        max,
        value: value[1],
        type: "range",
        onChange,
        name: "max-input",
        step,
        $values: value,
        onMouseDown: () => {
          setIsTooltipOpen(true);
        },
        onMouseUp: () => {
          setIsTooltipOpen(false);
        },
        $isRange: isRange,
        $isDisabled: isDisabled,
        disabled: isDisabled
      }), /* @__PURE__ */ jsx(Thumb, {
        isTooltipOpen: isTooltipOpen && !isTooltipHidden,
        min,
        max,
        value: value[1],
        inputPosition,
        isInactive,
        isDisabled
      })]
    })]
  });
}
export {
  RangeInput
};
//# sourceMappingURL=RangeInput.js.map
